import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  useCreateRetencion,
  useFetchCompras,
  useUpdateRetencion,
  usefetchProveedor,
} from "@/shared/actions/erp";
import {

  SingleTableBoxScene,
  NestedTabsScene,
  FormTabsOnly,
  CustomTabPanel,
  SampleDatePicker,
  SwitchComponenteForm,
  CustomAutocomplete,
  CustomTextField,
} from "@/shared/components/ui";
import {
  Compra,
  PROVEEDOR,
  Retencion,

} from "@/shared/interfaces";
import {Grid, Tab } from "@mui/material";
import { a11yProps, gridSizeMdLg4} from "@/shared";
import { useUiStore } from "@/store/ui";
import { newRetencionesSchema } from "@/shared";
import CompraRetencionDynamicTable from "../components/compraTableDynamic/compraRetencionTableDynamic";



const returnUrlRetencion = "/compras/retencion-compra";


type SaveFormData = {
  fecha_emision:string;
  aurorizacion:string;
  concepto:string;
  fecha_ingreso:string;
  fecha_caducacion:string; 
  detalles?:string[];
  numero_retencion:string;
  serie_retencion:string;
  base_imponible_iva:string;
  base_imponible_ice:string;
  base_imponible_ir:string;
  es_fisica:boolean;
  asumir_retencion:boolean;
  estado:boolean;
  compra?:string;
  proveedor:string;
};

export interface SaveRetencionInterface {
  titlePage: string;
  editRetencion?: Retencion;
}

const SaveRetencion: React.FC<SaveRetencionInterface> = ({
  titlePage,
  editRetencion,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
     useState("");
  


  const [RetencionChange, setRetencionChange] = useState(1);

  const [open, setOpen] = useState(false);

  
  const handleRetencionChange = useCallback((_event: any, value: any) => {
    setRetencionChange(value);
  }, []);



  
  const createRetencionMutation = useCreateRetencion({navigate, returnUrl:returnUrlRetencion});
  const updateRetencionMutation = useUpdateRetencion({navigate, returnUrl:returnUrlRetencion});



  const form = useForm<SaveFormData>({
    resolver: yupResolver(newRetencionesSchema),
   });


  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;
  
  


  const setAlert = useUiStore.getState().setAlert;
 
  const { data: ProveedorPaging, isLoading: isLoadingProveedor } =
    usefetchProveedor({
      page_size: 600,
    });
    const { data: compraPaging, isLoading: isLoadingcompra } =
    useFetchCompras({
      page_size: 600,
    });
  const onSave = async() => {

    if (!isValid) {
      return;
    }
    ///* upd
    if (editRetencion?.id_retencion) {
      return updateRetencionMutation.mutate(
        {
          id: editRetencion.id_retencion,
          data: {
            ...form.getValues(),
          } as any,
        },
        {
          onSuccess: () => {
            reset(); // reset form after successful update
          },
        }
      );
    }

    ///* create
    return createRetencionMutation.mutate(
      {
        ...form.getValues(),
      } as any,
      {
        onSuccess: () => {
          reset();
        },
      }
    );
  };

  ///* effects
  useEffect(() => {
    if (editRetencion) {
      setShrink(true);
      reset({
        ...editRetencion  
      } as any);
  
    }
  }, [editRetencion]);

 


  return (
    <>
      <SingleTableBoxScene
        title={titlePage}
        enableBackBtn={true}
        backPageUrl="/compras/retencion-compra"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {
          setAlert(true, 'Faltan campos por llenar', 'error');
        })}
      >
         <NestedTabsScene
          tabs={
            <FormTabsOnly
              onChange={handleRetencionChange}
              value={RetencionChange}
              // justifyContent="flex-end"
            >
              <Tab label="Retención" value={1} {...a11yProps(1)} />
            </FormTabsOnly>
          }
        >
        <Grid container spacing={3}>
        <CustomTabPanel index={RetencionChange} value={1}>
<>
<SampleDatePicker
              label="fecha emisión"
              control={control}
              error={errors.fecha_emision}
              helperText={errors.fecha_emision?.message}
              name="fecha_emision"
              textFieldKey="fecha_emision"
              size={gridSizeMdLg4}
              defaultValue={new Date().toISOString().split("T")[0]}
              readonly={true}
            />
            <SampleDatePicker
              label="fecha caducidad"
              control={control}
              error={errors.fecha_caducacion}
              helperText={errors.fecha_caducacion?.message}
              name="fecha_caducacion"
              textFieldKey="fecha_caducacion"
              size={gridSizeMdLg4}
              defaultValue={new Date().toISOString().split("T")[0]}
              readonly={true}
            />
            <SampleDatePicker
              label="fecha ingreso"
              control={control}
              error={errors.fecha_ingreso}
              helperText={errors.fecha_ingreso?.message}
              name="fecha_ingreso"
              textFieldKey="fecha_ingreso"
              size={gridSizeMdLg4}
              defaultValue={new Date().toISOString().split("T")[0]}
              readonly={true}
            />
<CustomTextField
          name="numero_retencion"
          label="Numero retención"
          control={form.control}
          defaultValue={form.getValues().numero_retencion || ''}
          error={errors.numero_retencion}
          helperText={errors.numero_retencion?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
<CustomTextField
          name="aurorizacion"
          label="Autorización"
          control={form.control}
          defaultValue={form.getValues().aurorizacion || ''}
          error={errors.aurorizacion}
          helperText={errors.aurorizacion?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
<CustomTextField
          name="concepto"
          label="Concepto"
          control={form.control}
          defaultValue={form.getValues().concepto || ''}
          error={errors.concepto}
          helperText={errors.concepto?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />


<CustomTextField
          name="serie_retencion"
          label="Serie retención"
          control={form.control}
          defaultValue={form.getValues().serie_retencion || ''}
          error={errors.serie_retencion}
          helperText={errors.serie_retencion?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
<CustomTextField
          name="base_imponible_iva"
          label="Base imponible iva"
          control={form.control}
          defaultValue={form.getValues().base_imponible_iva || ''}
          error={errors.base_imponible_iva}
          helperText={errors.base_imponible_iva?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
<CustomTextField
          name="base_imponible_ice"
          label="Base imponible ice"
          control={form.control}
          defaultValue={form.getValues().base_imponible_ice || ''}
          error={errors.base_imponible_ice}
          helperText={errors.base_imponible_ice?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
<CustomTextField
          name="base_imponible_ir"
          label="Base imponible ir"
          control={form.control}
          defaultValue={form.getValues().base_imponible_ir || ''}
          error={errors.base_imponible_ir}
          helperText={errors.base_imponible_ir?.message}
          shrink={shrink}
          size={gridSizeMdLg4}
        />
        <CustomAutocomplete<Compra>
            label="Compra"
            name="compra"
            //// options
            options={compraPaging?.data.data || []}
            // label & search by name
            valueKey="numero_autorizacion"
            actualValueKey='codigo'
            //
            defaultValue={form.getValues().compra || ''}
            optionLabelForEdit={form.getValues().compra || ''}
            isLoadingData={isLoadingcompra}
            //// validation
            control={form.control}
            error={errors.compra}
            helperText={errors.compra?.message}
            onChangeValue={(e)=>{
              form.setValue('compra', e)
            }}
            size={gridSizeMdLg4}
          /> 
        <CustomAutocomplete<PROVEEDOR>
            label="Proveedor"
            name="proveedor"
            //// options
            options={ProveedorPaging?.data.data || []}
            // label & search by name
            valueKey="razon_social"
            actualValueKey='codigo'
            //
            defaultValue={form.getValues().proveedor || ''}
            optionLabelForEdit={form.getValues().proveedor || ''}
            isLoadingData={isLoadingProveedor}
            //// validation
            control={form.control}
            error={errors.proveedor}
            helperText={errors.proveedor?.message}
            onChangeValue={(e)=>{
              form.setValue('proveedor', e)
            }}
            size={gridSizeMdLg4}
          /> 
        <Grid container item >
<SwitchComponenteForm
              control={control}
              defaultValue={form.getValues().es_fisica || true}
              label={"Es fisica"}
              name="es_fisica"
            />
</Grid>
<Grid container item >
<SwitchComponenteForm
              control={control}
              defaultValue={form.getValues().asumir_retencion || true}
              label={"Asumir retención"}
              name="asumir_retencion"
            />
</Grid>
<Grid container item >
<SwitchComponenteForm
              control={control}
              defaultValue={form.getValues().estado || true}
              label={"Estado"}
              name="estado"
            />
</Grid>

</>
         </CustomTabPanel>
        </Grid>
        </NestedTabsScene>
        <CompraRetencionDynamicTable open={open} setOpen={setOpen} />
      </SingleTableBoxScene>
    </>
  );
};

export default SaveRetencion;
